import {BaseForm} from "./base-form";

export class GuideForm extends BaseForm {
  public components: any[];
}
